import React, { useState } from "react";
import { XCircle } from "lucide-react";
import "../css-dashboard/Dashboard.css";
import { Link } from "react-router-dom";
import TravelAgency from "../../assets/travel-agency.svg";
import Reward from "../../assets/reward.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import SidebarClient from "../../components/sidebar-dashboard/SidebarClient";
import ClientTripsProgressNegotiations from "../../components/client-trips-negotiations/ClientTripsProgressNegotiations";
import UseClientTripsNegotiations from "../../hooks/UseTripsNegotiations/UseClientTripsNegotiations";
import UseNotAcceptOrderTripNegotiation from "../../hooks/UseNotAcceptOrderTripNegotiation/UseNotAcceptOrderTripNegotiation";
import UseModalReceiverData from "../../hooks/UseModalReceiverData/UseModalReceiverData";
import ModalReceiverData from "../../components/modal-receiver-data/ModalReceiverData";
import UseModalPhotosOrder from "../../hooks/UseModalPhotosOrder/UseModalPhotosOrder";
import ModalPhotosOrder from "../../components/modal-photos-order/ModalPhotosOrder";
import UseModalChat from "../../hooks/UseModalChat/UseModalChat";
import ModalChat from "../../components/modal-chat/ModalChat";

const DashboardClient = ({ menuOpen, setMenuOpen }) => {
  const [showRefuseModal, setShowRefuseModal] = useState(false);
  const [serieCancelOrder, setSerieCancelOrder] = useState("");

  console.log(menuOpen);

  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseClientTripsNegotiations();

  const {
    isOpenReceiverData,
    showSuccessScreenReceiverData,
    openModalReceiverData,
    closeModalReceiverData,
    selectedNegotiationReceiverData,
    formDataReceiverData,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingReceiverData,
    errorReceiverData,
    successReceiverData,
    errorsReceiverData,
  } = UseModalReceiverData(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenPhotosOrder,
    showSuccessScreenPhotosOrder,
    selectedNegotiationPhotosOrder,
    photosPhotosOrder,
    loadingPhotosOrder,
    errorPhotosOrder,
    successPhotosOrder,

    openPhotosOrderModal,
    closePhotosOrderModal,

    handleChangePhotoOrder,
    handleSubmitPhotosOrder,
  } = UseModalPhotosOrder(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenChat,
    selectedNegotiationChat,
    currentRoleChat,
    messagesChat,
    messageChat,
    emojiList,
    setShowEmojiPickerChat,
    showEmojiPickerChat,
    handleEmojiSelect,
    loadingMessagesChat,
    sendingChat,
    errorChat,
    messagesEndRef,
    openChatModal,
    closeChatModal,
    handleMessageChange,
    handleSendMessage,
  } = UseModalChat(() => {
    refetchTripsNegotiations();
  });

  const { loadingCancelOrder, cancelOrder } =
    UseNotAcceptOrderTripNegotiation();

  const handleCancelOrder = async (serie) => {
    await cancelOrder(serie, "client");
    setShowRefuseModal(false);
  };

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarClient menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Cliente</h1>
            <p className="breadcrumb">
              <a href="/dashboard-client">Início</a> / Dashboard do Cliente
            </p>
          </div>

          <section className="stats-grid">
            <div className="stat-card">
              <div className="dashboard-icon blue">
                <img src={Reward} alt="" />
              </div>

              <div className="stat-info">
                <span>Solicitações em Andamento</span>
                <h2 className="total-earns">
                  {
                    tripsNegotiations.filter((item) =>
                      [
                        "1",
                        "2",
                        "3",
                        "destinatario_recusou",
                        "4",
                        "5",
                        "6",
                        "7",
                      ].includes(item.trip_status),
                    ).length
                  }
                </h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>

            <div className="stat-card">
              <div className="dashboard-icon teal">
                <img src={TravelAgency} alt="" />
              </div>

              <div className="stat-info">
                <span>Encomendas Enviadas</span>
                <h2>
                  {
                    tripsNegotiations.filter((item) =>
                      ["8"].includes(item.trip_status),
                    ).length
                  }
                </h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>

            <div className="stat-card">
              <div className="dashboard-icon orange">
                <img src={EmAndamento} alt="" />
              </div>

              <div className="stat-info">
                <span>Encomendas não Efetivadas</span>
                <h2>0</h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>
          </section>

          <ClientTripsProgressNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverModal={openModalReceiverData}
            onOpenPhotosOrderModal={openPhotosOrderModal}
            onOpenChatModal={openChatModal}
            setSerieCancelOrder={setSerieCancelOrder}
            setShowRefuseModal={setShowRefuseModal}
          />
        </main>
      </div>

      <ModalReceiverData
        isClient={true}
        isOpenReceiverData={isOpenReceiverData}
        showSuccessScreenReceiverData={showSuccessScreenReceiverData}
        closeModalReceiverData={closeModalReceiverData}
        formDataReceiverData={formDataReceiverData}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingReceiverData={loadingReceiverData}
        errorReceiverData={errorReceiverData}
        errorsReceiverData={errorsReceiverData}
        successReceiverData={successReceiverData}
        selectedNegotiationReceiverData={selectedNegotiationReceiverData}
      />

      <ModalPhotosOrder
        isOpenPhotosOrder={isOpenPhotosOrder}
        closePhotosOrderModal={closePhotosOrderModal}
        showSuccessScreenPhotosOrder={showSuccessScreenPhotosOrder}
        selectedNegotiationPhotosOrder={selectedNegotiationPhotosOrder}
        photosPhotosOrder={photosPhotosOrder}
        loadingPhotosOrder={loadingPhotosOrder}
        errorPhotosOrder={errorPhotosOrder}
        successPhotosOrder={successPhotosOrder}
        modePhotosOrder="upload"
        handlePhotoChange={handleChangePhotoOrder}
        handleSubmit={handleSubmitPhotosOrder}
      />

      <ModalChat
        isOpenChat={isOpenChat}
        selectedNegotiationChat={selectedNegotiationChat}
        currentRoleChat={currentRoleChat}
        messagesChat={messagesChat}
        messageChat={messageChat}
        emojiList={emojiList}
        setShowEmojiPickerChat={setShowEmojiPickerChat}
        showEmojiPickerChat={showEmojiPickerChat}
        handleEmojiSelect={handleEmojiSelect}
        loadingMessagesChat={loadingMessagesChat}
        sendingChat={sendingChat}
        errorChat={errorChat}
        messagesEndRef={messagesEndRef}
        closeChatModal={closeChatModal}
        handleMessageChange={handleMessageChange}
        handleSendMessage={handleSendMessage}
      />

      {showRefuseModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowRefuseModal(false)}
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "90%",
              maxWidth: "500px",
              background: "#fff",
              borderRadius: "24px",
              padding: "30px",
              textAlign: "center",
              boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            }}
          >
            <XCircle
              size={70}
              color="#ef4444"
              style={{ marginBottom: "16px" }}
            />

            <h2
              style={{
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              Confirmar cancelamento
            </h2>

            <p
              style={{
                color: "#6b7280",
                lineHeight: 1.6,
                marginBottom: "24px",
              }}
            >
              Tem certeza que deseja cancelar a encomenda?
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                onClick={() => setShowRefuseModal(false)}
                className="action-btn ghost"
                style={{
                  width: "50%",
                  height: "50px",
                }}
              >
                Voltar
              </button>

              <button
                type="button"
                className="refuse-order-btn"
                onClick={() => handleCancelOrder(serieCancelOrder)}
                disabled={loadingCancelOrder}
                style={{
                  width: "50%",
                  height: "50px",
                }}
              >
                {loadingCancelOrder ? "Cancelando..." : "Sim, cancelar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardClient;
